
export default {
  title: 'Operation successful!',
  get_more_tokens: 'Acquire more OCC Tokens',
  or: 'Or',
  go_to_evaluations_list: 'Go to the list of assessments',
  information: 'If you want to acquire more OCC Tokens, go to Suite Operations'
}
